import React from "react";
import { VariantBase } from "scmp-sdk/components/newsletter/newsletter-widget/variants/component";

import { Container, theme } from "./styles";
export { config as newsletterArticleBottomThemeConfig } from "./config";

export const NewsletterArticleBottomTheme: React.FunctionComponent<{
  children?: React.ReactNode;
}> = ({ children, ...props }) => (
  <VariantBase theme={theme}>
    <Container {...props}>{children}</Container>
  </VariantBase>
);

NewsletterArticleBottomTheme.displayName = "NewsletterArticleBottomTheme";
